// Funções de decisão do seletor de prefeitura (sem React nem acesso a storage),
// para serem testadas isoladamente.

export const MENSAGEM_ERRO_PADRAO =
  "Não foi possível trocar de prefeitura. Tente novamente.";

// Só o perfil trimap (suporte) troca de prefeitura, tenha ou não prefeitura padrão no token.
export function podeTrocarPrefeitura(usuario) {
  return !!usuario && usuario.usuarioId !== undefined && usuario.perfil === "trimap";
}

// Prefeitura 0 no token: o trimap ainda não tem prefeitura e precisa escolher uma.
export function escolhaObrigatoria(prefeituraDoToken) {
  return !prefeituraDoToken;
}

function normalizar(texto) {
  return String(texto === undefined || texto === null ? "" : texto)
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();
}

// Filtra as prefeituras pelo nome exibido (prefeituraTopo): "contém", sem diferenciar
// caixa nem acento. Texto vazio devolve a lista inteira.
export function filtrarPrefeituras(prefeituras, texto) {
  const lista = prefeituras || [];
  const busca = normalizar(texto);
  if (busca === "") {
    return lista;
  }
  return lista.filter((p) => normalizar(p.prefeituraTopo).includes(busca));
}

export function mensagemDoErro(erro) {
  const dados = erro && erro.response ? erro.response.data : undefined;
  if (typeof dados === "string" && dados.trim() !== "") {
    return dados;
  }
  if (dados && typeof dados.message === "string" && dados.message !== "") {
    return dados.message;
  }
  return MENSAGEM_ERRO_PADRAO;
}

// Chama reload_tenant. Só com sucesso grava a sessão nova; em erro nada é gravado e o
// token atual continua valendo.
export async function aplicarTroca({ api, tokenAtual, prefeituraId, gravarSessao }) {
  try {
    const resposta = await api.post("/login/reload_tenant", {
      actualToken: tokenAtual,
      prefeituraId,
    });
    gravarSessao(resposta.data);
    return { ok: true, data: resposta.data };
  } catch (erro) {
    return { ok: false, mensagem: mensagemDoErro(erro) };
  }
}
